// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/styles/reset.css'
import '@/assets/styles/border.css'
import '@/assets/styles/index.css'
import resize from '@/lib/js/resize'
import toast from '@/components/toast/index'
import store from './store'
import {
  setStore,
  getStore,
  removeStore
} from "@/lib/js/storage";

resize()

Vue.config.productionTip = false
Vue.prototype.$toast = toast
Vue.prototype.setStore = setStore;
Vue.prototype.getStore = getStore;
Vue.prototype.removeStore = removeStore;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js